// src/services/record-management/types.ts
type UnaryFilterOperator = "empty" | "not_empty";
export type FilterOperator =
    | "eq"
    | "neq"
    | "on"
    | "not_on"
    | "relative_last"
    | "contains"
    | "not_contains"
    | "in"
    | "gt"
    | "gte"
    | "lt"
    | "lte"
    | "between"
    | "stw"
    | "edw"
    | "eq_dynamic"
    | "neq_dynamic"
    | "gt_dynamic"
    | "gte_dynamic"
    | "lt_dynamic"
    | "lte_dynamic"
    | UnaryFilterOperator;

export const UNARY_OPERATORS = new Set<UnaryFilterOperator>([
    "empty",
    "not_empty",
]);

export interface SortParams {
    field: string;
    direction?: "asc" | "desc";
}

export interface PaginationParams {
    page?: number;
    perPage?: number;
}

export interface RecordsResponse<T> {
    data: T[];
    meta: {
        page: number;
        per_page: number;
        total: number;
        permissions?: { read: boolean; create: boolean; update: boolean; delete: boolean };
    };
}

export type QueryHashParams =
    | { field: string; operator: FilterOperator; value: any }
    | { field: string; value: any };

export type FilterMap = Partial<Record<FilterOperator, any>>;
export type AndFilters = Record<string, FilterMap>;
export type OrCondition = Record<string, FilterMap>;

// NEW TYPES FOR QUERY NODES (AST)

export type LogicalOperator = "and" | "or";

export type Node = LogicalNode | ConditionNode | ExistsNode;

export interface LogicalNode {
    type: "logical";
    operator: LogicalOperator;
    conditions: Node[];
}

export interface ConditionNode {
    type: "condition";
    field: string;
    operator: FilterOperator | string;
    value?: unknown;
}

export interface ExistsNode {
    type: "exists";
    table: string;
    conditions: ConditionNode[];
}

export type SortDirection = "asc" | "desc";

export interface OrderBy {
    field: string;
    direction: SortDirection;
}

export interface Pagination {
    page: number;
    perPage: number;
}

export type ReferenceMode = "id" | "display";
